import { Model, Factory, belongsTo, hasMany } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import {
  rand,
  randSentence,
  randPastDate,
  randRecentDate,
  randUuid,
} from '@ngneat/falso'

import type { SchemaAttributes } from '../../types.js'
import type { MockServer } from '../server.js'
import { CONSTANTS } from './constants.js'
import type { ParticipantInstance } from './Conversation.js'

export type MessageData = SchemaAttributes<'ConversationMessage'>

export const model = (Model as ModelDefinition<MessageData>).extend({
  conversation: belongsTo('conversation'),
  sender: belongsTo('participant'),
  messageReceipts: hasMany('messageReceipt'),
})

export const factory = Factory.extend<MessageData>({
  external_id() {
    return randUuid()
  },
  message_type() {
    return CONSTANTS.message.defaultType
  },
  content() {
    return randSentence()
  },
  direction() {
    return rand([...CONSTANTS.message.directions])
  },
  created_at() {
    return randPastDate({
      years: CONSTANTS.conversation.dateRange.years,
    }).toISOString()
  },
  updated_at() {
    return randRecentDate().toISOString()
  },
  afterCreate(message, server) {
    const typedServer = server as MockServer
    const participants =
      (message.conversation?.participants?.models as ParticipantInstance[]) ??
      []
    for (const participant of participants) {
      typedServer.create('messageReceipt', {
        message,
        participant,
      })
    }
  },
})

export function routes(server: MockServer) {
  server.resource('message')
}

export function seeds() {}
